module.exports = __webpack_public_path__ + "static/media/keyboardTextInput.d3355b69.pdf";